/** Keyboard shortcuts shown in the player's "?" popover and in Settings (design: interactions.md). */
export const SHORTCUTS: [what: string, key: string][] = [
  ['Play / pause', 'Space'],
  ['Back / forward a beat', '← →'],
  ['Back / forward a bar', 'Shift ← →  or  PageUp / PageDown'],
  ['Loop on / off', 'L'],
  ['Metronome on / off', 'M'],
  ['Slower / faster', '− +'],
  ['Transpose down / up', '[ ]'],
  ['Timeline / Grid / Stage / Neck view', '1 2 3 4'],
  ['Fullscreen', 'F'],
  ['Show shortcuts', '?'],
];
